import 'react';

import styled, { type StyledComponent } from '@emotion/styled';

import { ResponsiveBreakPoints } from '~/constants/responsive';
import { colors, fontWeight } from '~/styles/constants';

interface Props {
  className?: string;
  hideBorder?: boolean;
  noPadding?: boolean;
}

const Footer = styled('footer')<Props>`
  padding: ${(props) => (props.noPadding ? (props.hideBorder ? '0' : '15px 0 0') : '15px 30px')};
  border-top: ${(props) => (props.hideBorder ? 'none' : `1px solid ${colors.gray50}`)};
  text-align: right;

  & button {
    :not(:first-of-type) {
      margin-left: 10px;
    }
  }
  background: ${colors.white};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

// footer will always shrink to let the Content that it succeeds to grow to fill space
// eslint-disable-next-line @typescript-eslint/ban-types
export const MobileFooter: StyledComponent<{}, Props, {}> = styled(Footer)`
  font-weight: ${fontWeight.normal};
  display: block;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  @media screen and (min-width: ${ResponsiveBreakPoints.Mobile}px) {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    bottom: auto;
    left: auto;
    right: auto;
  }
`;

export default Footer;
